require('bootstrap');

import './reels';
import './rooms';
import SwipeHelper from "./swipeHelper";

new SwipeHelper('#hospital, #heart');
